type ReportAssetDisplayInput = {
	rigName?: string;
	rigImage?: string;
	wellName?: string;
	wellId?: string;
	operatorKey?: string;
};

type ReportAssetDisplay = {
	rigName: string;
	wellName: string;
	image?: string;
	shouldFetchWell: boolean;
};

export function getReportAssetDisplay({
	rigName,
	rigImage,
	wellName,
	wellId,
	operatorKey,
}: ReportAssetDisplayInput): ReportAssetDisplay {
	return {
		rigName: rigName ?? "N/A",
		wellName: wellName ?? "N/A",
		image: rigImage,
		shouldFetchWell: !wellName && !!wellId && !!operatorKey,
	};
}
